<template>
  <div class="button_warp" @click="jumpToOrder('https://www.linkedin.com/showcase/hecoos')">
    <div class="botton_top">
      <i class="iconfont icon-linkedinlinkedin7"></i>
    </div>
    <div class="botton_bottom">
      Learn More
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jumpToOrder(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.button_warp {
  position: fixed;
  left: 72px;
  bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  cursor: pointer;


  .botton_top {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: #fff;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);


    i {
      line-height: 72px;
      font-size: 32px;
      color: #008dc2;
    }
  }

  .botton_bottom {
    background-color: #3c6ee0;
    color: #fff;
    text-align: center;
    padding: 8px 16px;
    transform: translateY(-14px);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

}
</style>